import { EmoticonSadIcon } from './EmoticonSadIcon';

/**
 * author: Michael Irigoyen
 * id CDA3C920-C286-4000-A7FC-C530CBC62CF7
 * name emoticon-sad
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-sad.svg
 * tags
 * - Emoji 
 */
export const EmojiSadIcon = EmoticonSadIcon;
export default EmojiSadIcon